import { Modal } from 'bootstrap';

document.addEventListener('DOMContentLoaded', () => {
  const modalElement = document.getElementById('onboardingVideoModal');
  if (!modalElement) {
    return;
  }

  const iframe = modalElement.querySelector<HTMLIFrameElement>('#onboardingVideoFrame');
  const modal = new Modal(modalElement);

  const titleElement = modalElement.querySelector<HTMLElement>('.modal-title');

  document.querySelectorAll<HTMLElement>('[data-onboarding-video]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const url = trigger.getAttribute('data-onboarding-video');
      if (!url || !iframe) {
        return;
      }

      const title = trigger.getAttribute('data-onboarding-video-title') ?? 'Onboarding video';
      const autoplayUrl = url.includes('?') ? `${url}&autoplay=1` : `${url}?autoplay=1`;

      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
      ); // youtube embed sometimes doesn't work without these permissions so it is better to keep them I think
      iframe.setAttribute('allowfullscreen', 'true');
      iframe.src = autoplayUrl;

      if (titleElement) {
        titleElement.textContent = title;
      }

      modal.show();
    });
  });

  modalElement.addEventListener('hidden.bs.modal', () => {
    if (iframe) {
      iframe.src = '';
      iframe.removeAttribute('allow');
      iframe.removeAttribute('allowfullscreen');
    }
    window.location.reload();
  });
});
